import { parseProductResponse } from '~/utils/parse-product-response';
import Axios from '~/utils/axios';
import { useQuery } from 'react-query';
import { sentryCaptureException } from '~/errors/sentry';
type ProductListFilterProps = {
   searchTerm?: string | null;
   statusFilter?: string | null;
   pageNumber?: number | null;
   per_page?: number | null;
   lang?: string;
   for_attendees?: boolean;
};
const useProductList = ({
   searchTerm,
   statusFilter,
   pageNumber,
   per_page,
   lang,
   for_attendees,
}: ProductListFilterProps) => {
   const getProductsList = async ({ queryKey }: any) => {
      const { statusFilter, searchTerm, per_page, lang, for_attendees } = queryKey[1];
      const apiEndpoint = '/hy-providers/v1/products';
      const params = {
         search: searchTerm || null,
         page: pageNumber,
         status: statusFilter && [`${statusFilter}`],
         per_page: per_page || 10,
         lang: lang,
         for_attendees: for_attendees,
      };
      const { data } = await Axios.get(apiEndpoint, { params });
      data.data = data.data.map((item: any) => parseProductResponse(item));
      return data;
   };

   return useQuery(
      ['products-list', { searchTerm, statusFilter, pageNumber, per_page, lang, for_attendees }],
      getProductsList,
      {
         refetchOnWindowFocus: false,
         onError: (error: Error) => {
            sentryCaptureException(error, { tags: { journey: 'business' } });
         },
      }
   );
};
export default useProductList;
